export const notificationConstants = {
  // GET_ALL: 取得所有推播訊息
  GET_ALL_REQUEST: "NOTIFICATION_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "NOTIFICATION_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "NOTIFICATION_GET_ALL_FAILURE",
  RESET_ALL_SUCCESS: "NOTIFICATION_RESET_ALL_SUCCESS",
  // CREATE_NOTIFICATION: 建立推播訊息
  CREATE_NOTIFICATION_REQUEST: "NOTIFICATION_CREATE_NOTIFICATION_REQUEST",
  CREATE_NOTIFICATION_SUCCESS: "NOTIFICATION_CREATE_NOTIFICATION_SUCCESS",
  CREATE_NOTIFICATION_FAILURE: "NOTIFICATION_CREATE_NOTIFICATION_FAILURE",
  RESET_CREATE_NOTIFICATION_SUCCESS: "RESET_CREATE_NOTIFICATION_SUCCESS"
};
